export type NumericInput = number | string | null | undefined;

export type FormatNumberOptions = {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
};

const DEFAULT_INDIAN_FORMAT_OPTIONS: Required<FormatNumberOptions> = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
};

/** Parse API numbers or pre-formatted strings (Indian/Western comma styles). */
export function parseAmount(value: NumericInput): number {
  if (value === null || value === undefined) {
    return 0;
  }
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : 0;
  }
  const cleaned = String(value).trim().replace(/,/g, "");
  if (!cleaned) {
    return 0;
  }
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : 0;
}

/** Indian grouping (e.g. 5,00,000 or 1,00,968.75). */
export function formatNumber(
  value: NumericInput,
  options?: FormatNumberOptions
): string {
  const minimumFractionDigits =
    options?.minimumFractionDigits ??
    DEFAULT_INDIAN_FORMAT_OPTIONS.minimumFractionDigits;
  const maximumFractionDigits =
    options?.maximumFractionDigits ??
    DEFAULT_INDIAN_FORMAT_OPTIONS.maximumFractionDigits;

  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(parseAmount(value));
}

/** Prefix currency symbol with Indian number grouping. */
export function formatCurrencyValue(
  currencySymbol: string,
  value: NumericInput,
  options?: FormatNumberOptions
): string {
  return `${currencySymbol}${formatNumber(value, options)}`;
}
